import React, { memo, useEffect, useState } from 'react';
import TabComp from '@components/tabs';
import SubsidiariesTable from './subsidiariesTable';
// import { subsidiaryStaticData } from '@model';
import { Loading } from '@components';

// import '@style/modules/analysis/analysisRight.scss';
import '../../../../../styles/modules/analysis/analysisRight.scss';
import { getValueFromSearchParam, setURLSearchParam } from '@utils/history';
import { useHistory } from 'react-router-dom';
// import { connect } from 'react-redux';
// import actions from '@flux/action';

const Grid = ({
  data,
  expand,
  isShownInModal = false,
  stateSwitch,
  editButton,
  stateOfCurFuSwitch,
  reportDate,
}) => {
  const [show, setShow] = useState(false);
  const [showSub, setShowSub] = useState(true);
  const history = useHistory();
  const { tab: defaultValue = 0 } = getValueFromSearchParam('tab');

  const handelChange = (e, tab) => {
    setShowSub(false);
    setTimeout(() => {
      setShowSub(true);
    }, 300);
    setURLSearchParam(history, { tab });
  };

  useEffect(() => {
    setTimeout(() => {
      setShow(true);
    }, 300);
  }, []);

  return (
    <>
      {show ? (
        <TabComp
          defaultValue={defaultValue}
          onChange={handelChange}
          tabs={data.map((tab, index) => ({
            key: index,
            label: tab?.companyName || '-',
            children: showSub ? (
              <SubsidiariesTable
                {...tab}
                expand={expand}
                tabKey={index}
                isShownInModal={isShownInModal}
                stateSwitch={stateSwitch}
                editButton={editButton}
                stateOfCurFuSwitch={stateOfCurFuSwitch}
                reportDate={reportDate}
              />
            ) : (
              <div style={{ height: '31.25rem', width: '100%' }}>
                <Loading />
              </div>
            ),
          }))}
        />
      ) : (
        <div style={{ height: '31.25rem', width: '100%' }}>
          <Loading />
        </div>
      )}
    </>
  );
};

export default memo(Grid);
